const DarkFooter = () => {
  return (
    <footer className="py-4 text-sm text-center font-garet uppercase bg-dark text-light flex justify-center items-center">
      <div className="flex flex-col items-center">
        <div className="flex flex-col md:flex-row md:space-x-4 space-y-2 md:space-y-0 mb-2">
          <a
            href="/data/Privacy%20Notice.pdf"
            className="px-3 py-1 font-poppins font-bold uppercase text-light">
            Privacy Policy
          </a>
          <a
            href="/data/Terms%20of%20Use.pdf"
            className="px-3 py-1 font-poppins font-bold uppercase text-light">
            Terms of Use
          </a>
          <a
            href="disclosure"
            className="px-3 py-1 font-poppins font-bold uppercase text-light">
            Disclosure
          </a>
          <a
            href="/data/SEC%20Form%20ADV.pdf"
            className="px-3 py-1 font-poppins font-bold uppercase text-light">
            SEC Form ADV
          </a>
        </div>
        <p>
          © {new Date().getFullYear()} Firethorn Partners. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default DarkFooter;